import i18next from 'i18next'
import toast from 'react-hot-toast'
import {
	locationErrorCode,
	locationErrorLabelKey
} from '@/features/marquee/utils'
import { errorHandler } from '@/helpers/utils'

/**
 * A failed location write: the sentence for its code (OPSSTD-10100), 403s
 * included, since the server is the authority even when the UI hid the
 * control. Anything unknown falls back to the generic error toast.
 */
export const handleLocationError = (error: unknown) => {
	const code = locationErrorCode(error)
	if (code) {
		toast.error(i18next.t(locationErrorLabelKey(code)))
		return
	}
	errorHandler(error)
}
